// src/legal/PrivacyModal.jsx
export default function PrivacyModal({ onClose }) {
  return (
    <div style={overlayStyle} onClick={onClose}>
      <div style={modalStyle} onClick={e => e.stopPropagation()}>

        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 16, paddingBottom: 16, borderBottom: "1px solid #21262d" }}>
          <div>
            <h2 style={headingStyle}>Privacy Policy</h2>
            <p style={{ color: "#8b949e", fontSize: 12, margin: 0 }}>Effective Date: June 2025</p>
          </div>
          <button onClick={onClose} style={closeBtnStyle}>✕</button>
        </div>

        <div style={bodyStyle}>

          <Section title="Information We Collect">
            <strong style={{ color: "#c9d1d9" }}>Account data:</strong> When you sign up, we collect your email address and create a
            secure account. We do not collect your name unless you provide it.
            {"\n\n"}
            <strong style={{ color: "#c9d1d9" }}>Usage data:</strong> We store your token balance and transaction records (purchases and deductions).
            {"\n\n"}
            <strong style={{ color: "#c9d1d9" }}>Student writing:</strong> Text or files submitted for evaluation are transmitted to the
            Anthropic Claude API for processing. Writing Coach does not store the content of student writing
            after the evaluation response is returned to your browser.
          </Section>

          <Section title="How We Use Your Information">
            We use your email to send account-related communications (confirmation, password reset).
            We use token records to manage your balance. We do not use your data for advertising or
            sell it to third parties.
          </Section>

          <Section title="Children's Privacy (COPPA)">
            We are committed to protecting children's privacy. We do not knowingly collect personal
            information from children under 13 without verifiable parental consent. If you believe a
            child under 13 has created an account without parental consent, please contact us immediately
            at <a href="mailto:support@chaicodes.com" style={linkStyle}>support@chaicodes.com</a> and
            we will delete the account.
            {"\n\n"}
            For children under 13, parents or guardians may review, request deletion of, or refuse further
            collection of their child's personal information by contacting us.
          </Section>

          <Section title="Educational Records (FERPA)">
            When Writing Coach is used in a school setting, student writing submissions are considered
            educational records under FERPA. Writing Coach acts as a school official with a legitimate
            educational interest. We do not disclose educational records without proper authorization.
            Student writing is processed by Anthropic's Claude API solely for evaluation purposes and
            is not retained by Writing Coach.
          </Section>

          <Section title="Data Storage & Security">
            Account data is stored in Supabase, a secure cloud database. All data is encrypted in transit
            (TLS) and at rest. Payments are processed by Stripe; we never store payment card information.
          </Section>

          <Section title="Data Retention & Deletion">
            You may request deletion of your account and associated data at any time by emailing us.
            We will process your request within 30 days.
          </Section>

          <Section title="Third-Party Services">
            We use the following third-party services:
            {"\n"}• <strong style={{ color: "#c9d1d9" }}>Anthropic Claude API</strong> — AI evaluation processing. Writing is processed but not retained. See <a href="https://www.anthropic.com/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Anthropic's Privacy Policy</a>.
            {"\n"}• <strong style={{ color: "#c9d1d9" }}>Supabase</strong> — Secure database and authentication. See <a href="https://supabase.com/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Supabase's Privacy Policy</a>.
            {"\n"}• <strong style={{ color: "#c9d1d9" }}>Stripe</strong> — Payment processing. See <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" style={linkStyle}>Stripe's Privacy Policy</a>.
            {"\n"}• <strong style={{ color: "#c9d1d9" }}>Netlify</strong> — Hosting. See <a href="https://www.netlify.com/privacy/" target="_blank" rel="noopener noreferrer" style={linkStyle}>Netlify's Privacy Policy</a>.
          </Section>

          <Section title="Contact">
            Privacy questions or requests: <a href="mailto:support@chaicodes.com" style={linkStyle}>support@chaicodes.com</a>
          </Section>
        </div>

        <div style={{ paddingTop: 14, borderTop: "1px solid #21262d" }}>
          <button onClick={onClose} style={closeBtnFullStyle}>Close</button>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div style={{ marginBottom: 18 }}>
      <h3 style={{ fontSize: 13, fontWeight: 700, color: "#e6edf3", margin: "0 0 6px" }}>{title}</h3>
      <p style={{ fontSize: 13, color: "#8b949e", margin: 0, lineHeight: 1.75, whiteSpace: "pre-wrap" }}>
        {children}
      </p>
    </div>
  );
}

const overlayStyle = {
  position:       "fixed",
  inset:          0,
  background:     "rgba(0,0,0,0.85)",
  display:        "flex",
  alignItems:     "center",
  justifyContent: "center",
  zIndex:         300,
  padding:        "20px",
};

const modalStyle = {
  width:         "100%",
  maxWidth:      560,
  maxHeight:     "90vh",
  background:    "#161b22",
  border:        "1px solid #30363d",
  borderRadius:  16,
  padding:       "28px",
  display:       "flex",
  flexDirection: "column",
  fontFamily:    "'DM Sans', sans-serif",
};

const headingStyle = {
  fontFamily: "'DM Serif Display', serif",
  fontSize:   22,
  fontWeight: 400,
  color:      "#e6edf3",
  margin:     0,
};

const bodyStyle = {
  overflowY:    "auto",
  flex:         1,
  marginBottom: 8,
  paddingRight: 4,
};

const closeBtnStyle = {
  background:     "transparent",
  border:         "1px solid #30363d",
  color:          "#8b949e",
  borderRadius:   7,
  width:          32,
  height:         32,
  cursor:         "pointer",
  fontSize:       16,
  display:        "flex",
  alignItems:     "center",
  justifyContent: "center",
  flexShrink:     0,
};

const closeBtnFullStyle = {
  width:        "100%",
  padding:      "10px",
  borderRadius: 8,
  fontSize:     13,
  fontWeight:   600,
  border:       "1px solid #30363d",
  background:   "transparent",
  color:        "#8b949e",
  cursor:       "pointer",
  fontFamily:   "'DM Sans', sans-serif",
};

const linkStyle = {
  color:          "#388bfd",
  textDecoration: "underline",
};
